<template>
  <v-dialog
    v-model="dialog"
    persistent
    transition="dialog-bottom-transition"
    max-width="1000"
  >
    <div class="bg-white poppins">
      <div class="modal-header py-4 align-center">
        <h4 class="mb-0 font-weight-bolder">
          Add Call ({{ orderIds.length }} orders)
        </h4>
        <div
          class="btn btn-sm btn-icon btn-active-light-info"
          @click="toggleModal"
        >
          <span class="svg-icon">
            <v-icon size="22">mdi-close</v-icon>
          </span>
        </div>
      </div>
      <div class="modal-body d-flex flex-column scroll-y mx-5 mx-xl-15 py-7">
        <form id="bulkCreateForm" class="pa-3 row">
          <div class="col-12 col-sm-6">
            <v-select
              v-model="formData.call_status"
              label="Call status"
              item-text="text"
              item-value="index"
              :items="call_statuses"
              clearable
              required
              outlined
              dense
              :error-messages="call_statusErrors"
              @input="$v.formData.call_status.$touch()"
              @blur="$v.formData.call_status.$touch()"
            ></v-select>
          </div>
          <div class="col-12 col-sm-6" v-if="isDateFieldVisible">
            <v-datetime-picker
              label="Appointed to Date/Time"
              v-model="formData.date_time"
              prepend-icon="mdi-calendar"
              dense
              :datePickerProps="{
                min: tommorowDate,
              }"
              :textFieldProps="{
                outlined: true,
                dense: true,
              }"
            >
            </v-datetime-picker>
          </div>
          <div class="col-12 col-sm-6">
            <v-text-field
              v-model="formData.comment"
              label="Comment"
              outlined
              dense
              clearable
            ></v-text-field>
          </div>
          <div class="col-12 col-sm-6">
            <v-checkbox
              v-model="formData.order_validation"
              :true-value="true"
              :false-value="false"
              color="indigo"
              label="Order Validation"
              dense
            ></v-checkbox>
          </div>
        </form>
        <div class="my-4 d-flex flex-grow-1 align-end justify-center">
          <button
            type="reset"
            class="btn btn-light mr-3 px-5 py-3 ls1"
           
            @click="resetCreateForm"
          >
            Clear
          </button>
          <button
            type="submit"
            class="btn btn-info px-5 py-3 ls1"
           
            @click="submitCreateForm"
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import ApiService from "@/core/services/api.service";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import Swal from "sweetalert2";

const emptyForm = () => ({
  date_time: null,
  call_status: null,
  comment: null,
  order_validation: false,
});

export default {
  mixins: [validationMixin],
  validations: {
    formData: {
      call_status: { required },
    },
  },
  name: "BulkOrderCall",
  props: ["pageLoader", "call_statuses", "refresher"],
  data: () => ({
    dialog: false,
    orderIds: [],
    formData: emptyForm(),
  }),
  methods: {
    setData(orderIds) {
      this.orderIds = orderIds;
    },
    toggleModal() {
      if (this.dialog) {
        this.resetCreateForm();
      }
      this.dialog = !this.dialog;
    },
    validateData() {
      if (
        !this.formData.date_time &&
        (this.formData.call_status === 700 || this.formData.call_status === 800)
      ) {
        Swal.fire({
          title: "Warning",
          text: `Date is required!`,
          icon: "warning",
          showConfirmButton: false,
          timer: 2500,
        });
        return false;
      }
      return true;
    },
    submitCreateForm() {
      this.$v.$touch();
      if (this.$v.$invalid || !this.validateData()) return;

      const { call_status, comment, date_time, order_validation } =
        this.formData;
      const data = {
        order_ids: this.orderIds.map((orderId) => ({
          order_id: orderId,
          call_status,
          comment,
          appointed_at: date_time ? this.dateFormatter(date_time) : null,
          order_validation,
        })),
      };

      this.pageLoader(true);
      ApiService.post("/customer_service/call_sheets/add_call_bulk", data)
        .then(() => {
          Swal.fire({
            title: "Created",
            text: `Call added to ${data.order_ids.length} orders!`,
            icon: "success",
            showConfirmButton: false,
            timer: 2500,
          });
          this.toggleModal();
          this.refresher();
        })
        .catch(() => {
          this.pageLoader(false);
        });
    },
    resetCreateForm() {
      this.$v.$reset();
      this.formData = emptyForm();
    },
    handleFormValidation(fieldName) {
      const errors = [];
      if (!this.$v.formData[fieldName].$dirty) return errors;
      !this.$v.formData[fieldName].required &&
        errors.push("This field is required");
      return errors;
    },
    dateFormatter(d) {
      const pad = (n) => (n > 9 ? n : `0${n}`);
      return (
        [d.getFullYear(), pad(d.getMonth() + 1), pad(d.getDate())].join("-") +
        " " +
        [pad(d.getHours()), pad(d.getMinutes()), pad(d.getSeconds())].join(":")
      );
    },
  },
  computed: {
    tommorowDate() {
      let cdate = new Date();
      cdate.setDate(cdate.getDate() + 1);
      return cdate.toISOString().split("T")[0];
    },
    isDateFieldVisible() {
      return (
        this.formData.call_status === 700 || this.formData.call_status === 800
      );
    },
    call_statusErrors() {
      return this.handleFormValidation("call_status");
    },
  },
};
</script>
